/* eslint-disable jsx-a11y/prefer-tag-over-role */
import React, { MouseEventHandler } from 'react';
import {
  Container,
  MenuItemContent,
  MenuItemInner,
  ProhibitionReason,
  Suffix,
  Prefix,
} from './menu-item.styles';

export type MenuItemSize = 'small' | 'medium';
export type MenuItemContentWeight = 400 | 500 | 700;
export type MenuItemAppearance = 'default' | 'danger' | 'warning';

interface Props {
  suffix?: React.ReactNode;
  prefix?: React.ReactNode;
  children: React.ReactNode;
  prohibitionReason?: React.ReactNode;
  useFlagEmojiFont?: boolean;
  isSelected?: boolean;
  isDisabled?: boolean;
  appearance?: MenuItemAppearance;
  size?: MenuItemSize;
  contentWeight?: MenuItemContentWeight;
  showBackgroundOnSelected?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseUp?: MouseEventHandler<HTMLButtonElement>;
}

const MenuItem = ({
  isSelected,
  suffix,
  prefix,
  children,
  prohibitionReason,
  useFlagEmojiFont = true,
  isDisabled,
  appearance = 'default',
  size = 'medium',
  contentWeight = 400,
  showBackgroundOnSelected = true,
  onClick,
  onMouseUp,
}: Props) => (
  <Container>
    <MenuItemInner
      type='button'
      role='option'
      $size={size}
      $showBackgroundOnSelected={showBackgroundOnSelected}
      $contentWeight={contentWeight}
      $appearance={appearance}
      $isSelected={isSelected}
      $hasPrefix={!!prefix}
      $hasSuffix={!!suffix}
      aria-disabled={isDisabled}
      $isDisabled={isDisabled}
      className={useFlagEmojiFont ? 'flag-emoji-font' : undefined}
      onClick={onClick}
      onMouseUp={onMouseUp}>
      {prefix && <Prefix>{prefix}</Prefix>}
      <MenuItemContent>
        {children}
        {prohibitionReason && (
          <ProhibitionReason $appearance={appearance}>
            {prohibitionReason}
          </ProhibitionReason>
        )}
      </MenuItemContent>
      {suffix && <Suffix>{suffix}</Suffix>}
    </MenuItemInner>
  </Container>
);

export default MenuItem;
